import { Bell, Pointer, Sparkles } from "lucide-react";
import { BenefitItem } from "../AIReelGenration/components/benefit-item";

export default function AIBasedFestival() {
    return (
        <div className="mt-14 py-4">
            <div className="max-w-6xl mx-auto px-12 sm:px-4">
                {/* Header Section */}
                 <header className="text-center">
                    <h1 className="text-balance text-5xl md:text-4xl sm:text-3xl font-semibold tracking-tight text-[#0C0C0C]">
                        AI-Based Festival Celebrations
                    </h1>
                    <p className="mx-auto max-w-3xl mt-4 sm:mt-3 text-xs text-[#4D4D4D] text-pretty font-medium">
                        Make every festival a memorable and engaging experience for parents and students with AI-powered Festival Celebrations from SooMuch.Ai.
                    </p>
                </header>
                {/* Main Content Section */}
                <div className="mt-20 md:mt-12 sm:mt-8 grid grid-cols-2 md:grid-cols-1 gap-8 md:gap-6 sm:gap-4 items-start mb-12 md:mb-8 sm:mb-6">
                    {/* Left Side */}
                    <aside aria-label="Key features" className="self-center space-y-6 md:space-y-5 sm:space-y-4">

                        <h3 className="text-2xl md:text-base font-semibold">How it works:</h3>

                        <section>
                            <div className="flex items-start gap-3 mb-3">
                                <Bell className="text-blue-900 w-10" />
                                <div>
                                    <h3 className="text-lg md:text-base font-semibold">Smart Notifications</h3>
                                    <p className="mt-1 text-sm sm:text-xs text-muted-foreground">Schools receive notifications about upcoming festivals and greetings. They choose whether to celebrate or just send wishes.</p>
                                </div>
                            </div>
                        </section>

                        <section>
                            <div className="flex items-start gap-3 mb-3">
                                <Pointer className="text-blue-900 w-16" />
                                <div>
                                    <h3 className="text-lg md:text-base font-semibold">Consent-Based Celebration</h3>
                                    <p className="mt-1 text-sm sm:text-xs text-muted-foreground">
                                        <p><strong>If Schools Accept:</strong> Invitations for the festival are automatically created and shared with parents via the Parent App and WhatsApp. Festival posts and reels can be published on social media, keeping the school's branding as the main highlight</p>
                                        <p className="mt-4"><strong>If Schools Decline:</strong> Only festival greetings and best wishes from the school are sent to parents via the Parent App and shared on social media.</p>
                                    </p>
                                </div>
                            </div>
                        </section>

                        <section>
                            <div className="flex items-start gap-3 mb-3">
                                <Sparkles className="text-blue-900 w-12" />
                                <div>
                                    <h3 className="text-lg md:text-base font-semibold">AI-Enhanced Greetings and Invites</h3>
                                    <p className="mt-1 text-sm sm:text-xs text-muted-foreground">All festival invitations and greetings created are high quality and under the school’s branding, maintaining consistency and identity of the school as the rightful owner of the content. </p>
                                </div>
                            </div>
                        </section>
                    </aside>
                    {/* Right Side - Benefits */}
                    <div className="flex justify-center">
                        <img
                            src="/images/new-landing-page/aiFestivel1.png"
                            alt="Inspire 365 Dashboard showing Today's Lessons and Students"
                            className="w-[90%]"
                        />
                    </div>
                </div>
                {/* Bottom Text */}
                <section className="mt-14 md:mt-10 sm:mt-8">
                    <h2 className="text-center text-2xl font-semibold md:text-xl sm:text-lg">
                        Benefits
                    </h2>
                    <div className="mt-6 flex flex-wrap justify-center gap-6 md:gap-4 sm:mt-4 sm:gap-3">
                        <BenefitItem>Parents are informed and engaged in every festival or celebration.</BenefitItem>
                        <BenefitItem>Social media visibility and brand reach are enhanced.</BenefitItem>
                    </div>
                    <div className="mt-6 flex flex-wrap justify-center gap-6 md:gap-4 sm:mt-3 sm:gap-3">
                        <BenefitItem>Saves staff time by automating content creation and distribution.</BenefitItem>
                        <BenefitItem>Builds stronger parent-school relationships and reinforces the school’s identity professionally.</BenefitItem>
                    </div>
                </section>
            </div>
        </div>
    );
}